import { partyTaxStatus, type PartyTax } from '../../lib/partyTaxStatus'

// The EORI of the company under an Importer / Consignee box: the value when there is one, otherwise a plain NOTE (grey, no warning colour).
// An EORI is not always needed (only when we clear the shipment), so a missing one is information, not an error: the same wording as the
// AutoJobs confirm step, so both screens say the same thing. Nothing here decides whether we clear the job.
// EORI ONLY: the VAT number has nothing to do with the declaration, this page says nothing about it.
export default function PartyTaxIds({ tax, companyName, canEdit }: { tax: PartyTax; companyName: string | null; canEdit: boolean }) {
  if (tax.error && !tax.loaded) return <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">Could not load the EORI: {tax.error}</p>
  const s = partyTaxStatus(tax, canEdit)
  if (!s) return <p className="mt-1 text-xs text-gray-400">Loading EORI…</p>
  const who = companyName || 'this company'
  const eori = (tax.eori ?? '').trim()

  return (
    <div className="mt-2" data-testid="party-tax-ids">
      {s.eori === 'missing' ? (
        <p className="text-sm text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/40 rounded-md px-3 py-2">
          No EORI on file for {who}. If we clear this shipment, {canEdit ? 'add it (click the arrow ↗ on the right of the company box)' : 'ask Accounts, Sales or Operations to add it'}; otherwise leave it blank.
        </p>
      ) : s.eori === 'bad_format' ? (
        <p className="text-sm text-gray-600 dark:text-gray-300">
          <span className="text-gray-500 dark:text-gray-400">EORI</span>{' '}
          <span className="font-mono font-medium">{eori}</span>
          <span className="ml-2 text-xs text-amber-700 dark:text-amber-400">This does not look like an EORI (two letters, then 5-15 letters or digits). {canEdit ? 'Click the arrow ↗ on the right of the company box to correct it.' : 'Ask Accounts, Sales or Operations to correct it.'}</span>
        </p>
      ) : (
        <p className="text-sm text-gray-800 dark:text-gray-200">
          <span className="text-gray-500 dark:text-gray-400">EORI</span>{' '}
          <span className="font-mono font-medium">{eori.toUpperCase()}</span>
          {s.eori === 'ok_check_uk' && <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">Not the usual UK shape (GB + 9-12 digit VAT no. + 000): double-check if this looks wrong.</span>}
        </p>
      )}
    </div>
  )
}
